import { useEffect, useState } from 'react'
import { useResetRecoilState } from 'recoil'

import Modal from '@/shared/components/common/Modal/Modal'
import { useModal } from '@/shared/hooks/useModal'
import { SecurityNumState, TimeOutState, TranIdState } from '@/shared/store'

type TimerMonitor = {
  begin: (timeout: number) => boolean
  syncRemainingSec: (seconds: number) => void
  invalidate: () => void
}

const Timer = (props: any) => {
  const { time, monitor }: { time: string | number; monitor?: TimerMonitor | null } = props
  const timeoutSec = Number(time)
  const { isOpen, toggle } = useModal()
  const [minutes, setMinutes] = useState(timeoutSec / 60)
  const [seconds, setSeconds] = useState(timeoutSec % 60)
  const ResetTimeOut = useResetRecoilState(TimeOutState)
  const ResetTranId = useResetRecoilState(TranIdState)
  const ResetSecurityNum = useResetRecoilState(SecurityNumState)

  useState(() => {
    monitor?.begin(timeoutSec)
    return true
  })

  useEffect(() => {
    const countdown = setInterval(() => {
      if (Number(seconds) > 0) {
        setSeconds(Number(seconds) - 1)
      }
      if (Number(seconds) === 0) {
        if (Number(minutes) === 0) {
          clearInterval(countdown)
        } else {
          setMinutes(Number(minutes) - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    return () => clearInterval(countdown)
  }, [ResetTimeOut, minutes, seconds])

  useEffect(() => {
    monitor?.syncRemainingSec(Number(minutes) * 60 + Number(seconds))
  }, [minutes, seconds, monitor])

  useEffect(() => {
    return () => monitor?.invalidate()
  }, [monitor])

  useEffect(() => {
    if (minutes === 0 && seconds === 1) {
      const expired = setTimeout(() => {
        toggle()
      }, 1000)
      return () => clearTimeout(expired)
    }
  }, [minutes, seconds, toggle, monitor])
  return (
    <>
      <span>
        0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </span>
      <Modal
        isOpen={isOpen}
        type="alert"
        toggle={toggle}
        setOption={211}
        ClickFunc={() => {
          toggle()
          ResetTimeOut()
          ResetSecurityNum()
          ResetTranId()
          document.body.style.overflow = 'unset'
        }}
      />
    </>
  )
}

export default Timer
